<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Department"
}
</script>

<style scoped>

</style>